// import React, { useState, useEffect } from 'react';
// import { NavLink, useLocation, useNavigate } from 'react-router-dom';
// import { useSelector, useDispatch } from 'react-redux';
// import { toggleSidebar, setActiveModule } from '../../store/slices/uiSlice';
// import tenant from '../../config/tenant';
// import {
//   LayoutDashboard, Package, Handshake, DollarSign,
//   Users, Building2, ShoppingCart, Factory,
//   FileSignature, ChevronLeft, ChevronRight, X,
//   BarChart2, Briefcase, Clock, Calendar, Award, BookOpen,
//   User, ShieldAlert, LogOut, FileText, ChevronDown,
//   FolderOpen, Database, Settings, Clock3, Columns, FileSpreadsheet
// } from 'lucide-react';
// import { getLoggedInUserId } from '../../utils/masterDataUtils';
// import { fetchAccessPrivilegesByEmployee } from '../../store/slices/privilegeSlice';

// const FEATURE_FLAGS = {
//   ENABLE_MENU_PERMISSIONS: false,
// }

// // Define disabled menu items
// const DISABLED_MENU_CODES = ['ERP1038', 'ERP1039', 'ERP1040', 'ERP1041', 'ERP1042', 'ERP1043', 'ERP1044'];

// const navItems = [
//   { menuCode: 'ERP1001', path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
//   { menuCode: 'ERP1002', path: '/hrm', label: 'eHRM', icon: Users },
//   { menuCode: 'ERP1023', path: '/payroll', label: 'Payroll Process', icon: DollarSign },
//   { menuCode: 'ERP1038', path: '/asset', label: 'eAsset', icon: Package },
//   { menuCode: 'ERP1039', path: '/commercial', label: 'eCommercial', icon: Handshake },
//   { menuCode: 'ERP1040', path: '/finance', label: 'eFinancials', icon: DollarSign },
//   { menuCode: 'ERP1041', path: '/office', label: 'eOffice', icon: Building2 },
//   { menuCode: 'ERP1042', path: '/procurement', label: 'eProcurement', icon: ShoppingCart },
//   { menuCode: 'ERP1043', path: '/production', label: 'eProduction', icon: Factory },
//   { menuCode: 'ERP1044', path: '/subcontract', label: 'eSubcontract', icon: FileSignature },
//   //{ menuCode: 'ERP1045', path: '/master-files', label: 'Master Files', icon: Database },
// ];

// const HR_MODULES = [
//   { menuCode: 'ERP1003', key: 'overview', label: 'Overview', icon: BarChart2, route: '/hrm/dashboard' },
//   { menuCode: 'ERP1004', key: 'employees', label: 'Employee Management', icon: Users, route: '/hrm/employees' },
//   // { menuCode: 'ERP1005', key: 'analysis', label: 'Employee Analysis', icon: BarChart2, route: '/hrm/analysis' },
//   { menuCode: 'ERP1005', key: 'attendance-summary-details', label: 'Attendance Summary', icon: BarChart2, route: '/hrm/attendance/details' },
//   {
//     menuCode: 'ERP1046',
//     key: 'Overtime',
//     label: 'Overtime Management',
//     icon: Clock3,
//     route: '/hrm/OtManagement',
//     children: [
//       {
//         menuCode: 'ERP1046_MAIN',
//         key: 'ot_dashboard',
//         label: 'Overtime Dashboard',
//         route: '/hrm/overtime/dashboard'
//       },
//       {
//         menuCode: 'ERP1047',
//         key: 'ot_details',
//         label: 'Overtime Details',
//         route: '/hrm/overtime/details'
//       },
//     ]
//   },
//   // { menuCode: 'ERP1006', key: 'recruitment', label: 'Recruitment', icon: Briefcase },
//   { menuCode: 'ERP1007', key: 'masterfiles', label: 'Master Files', icon: Database },
//   {
//     menuCode: 'ERP1008',
//     key: 'attendance',
//     label: 'Attendance & Shifts',
//     icon: Clock,
//     children: [
//       {
//         key: 'attendance-summary',
//         label: 'Attendance Dashboard',
//         route: '/hrm/attendence-summery'
//       },
//       {
//         menuCode: 'ERP1009',
//         key: 'time_adjustments',
//         label: 'Time Adjustments',
//         route: '/hrm/attendance/adjustments'
//       },
//       {
//         menuCode: 'ERP1010',
//         key: 'attendance_approval',
//         label: 'Attendance Approval',
//         route: '/hrm/attendance/approval'
//       },

//     ]
//   },

//   {
//     menuCode: 'ERP1011',
//     key: 'leave',
//     label: 'Leave Management',
//     icon: Calendar,
//     children: [
//       {
//         menuCode: 'ERP1012_DASH',
//         key: 'leave_dashboard',
//         label: 'Leave Dashboard',
//         route: '/hrm/leave/dashboard'
//       },
//       {
//         menuCode: 'ERP1012',
//         key: 'leave_dashboard_reports',
//         label: 'Leave Reports',
//         route: '/hrm/leave/more/dashboard-reports'
//       },
//       {
//         menuCode: 'ERP1013',
//         key: 'leave_holiday_calendar',
//         label: 'Holiday Calendar',
//         route: '/hrm/leave/more/holiday-calendar'
//       },
//       {
//         menuCode: 'ERP1014',
//         key: 'leave_application_balance',
//         label: 'Leave Application',
//         route: '/hrm/leave/more/application-balance'
//       },
//       // {
//       //   menuCode: 'ERP1016',
//       //   key: 'leave_adjustments',
//       //   label: 'Leave Adjustments',
//       //   route: '/hrm/leave/adjustments'
//       // },
//       {
//         menuCode: 'ERP1015',
//         key: 'leave_configuration',
//         label: 'Leave Configuration',
//         route: '/hrm/leave/more/configuration'
//       },
//     ]
//   },
//   // { menuCode: 'ERP1016', key: 'performance', label: 'Performance', icon: Award },
//   // { key: 'Calendar', label: 'Calendar', icon: Calendar, route: '/hrm/calendar' },
//   // { menuCode: 'ERP1017', key: 'training', label: 'Training', icon: BookOpen },
//   // { menuCode: 'ERP1018', key: 'selfservice', label: 'Self Service', icon: User },
//   // { menuCode: 'ERP1019', key: 'disciplinary', label: 'Disciplinary', icon: ShieldAlert },
//   // { menuCode: 'ERP1020', key: 'hrassets', label: 'Assets', icon: Package },
//   // { menuCode: 'ERP1021', key: 'exit', label: 'Exit Management', icon: LogOut },
//   // { menuCode: 'ERP1022', key: 'reports', label: 'Reports', icon: FileText },
// ];

// const PAYROLL_MODULES = [
//   { menuCode: 'ERP1024', key: 'p_dashboard', label: 'Dashboard', icon: BarChart2, route: '/payroll/dashboard' },
//   { menuCode: 'ERP1025', key: 'p_masterfile', label: 'Master File Maintenance', icon: Database, route: '/payroll/master-file' },
//   { menuCode: 'ERP1026', key: 'p_employeesalary', label: 'Employee Salary', icon: Users, route: '/payroll/employee-salary' },
//   { menuCode: 'ERP1027', key: 'p_batches', label: 'Payroll Batches', icon: FolderOpen, route: '/payroll/batches' },
//   // { menuCode: 'ERP1028', key: 'p_overtime', label: 'Overtime', icon: Clock, route: '/payroll/overtime' },
//   { menuCode: 'ERP1029', key: 'p_loans', label: 'Loans & Advances', icon: DollarSign, route: '/payroll/loans-advances' },
//   { menuCode: 'ERP1030', key: 'p_processing', label: 'Payroll Processing', icon: Briefcase, route: '/payroll/processing' },
//   // { menuCode: 'ERP1031', key: 'p_approval', label: 'Payroll Approval', icon: ShieldAlert, route: '/payroll/approval' },
//   { menuCode: 'ERP1038', key: 'p_payrolltext', label: 'Payroll Text', icon: FileText, route: '/payroll/payroll-text' },
//   { menuCode: 'ERP1039', key: 'p_salarysummary', label: 'Salary Summary', icon: FileSpreadsheet, route: '/payroll/salary-summary' },
//   { menuCode: 'ERP1048', key: 'p_payrolltextcustom', label: 'Custom Payroll Text', icon: Columns, route: '/payroll/payroll-text-custom' },
//   { menuCode: 'ERP1032', key: 'p_payments', label: 'Payments', icon: DollarSign, route: '/payroll/payments' },
//   { menuCode: 'ERP1033', key: 'p_header', label: 'Payroll Header', icon: FileText, route: '/payroll/header' },
//   // { menuCode: 'ERP1034', key: 'p_payslips', label: 'Payslips', icon: FileSignature, route: '/payroll/payslips' },
//   // { menuCode: 'ERP1035', key: 'p_finance', label: 'Finance Integration', icon: Briefcase, route: '/payroll/finance-integration' },
//   { menuCode: 'ERP1036', key: 'p_reports', label: 'Reports', icon: FileText, route: '/payroll/reports' },
//   // { menuCode: 'ERP1037', key: 'p_utilities', label: 'Utilities', icon: Settings, route: '/payroll/utilities' },
// ];

// const hasMenuPermission = (menuCode, accessPrivileges) => {
//   if (!FEATURE_FLAGS.ENABLE_MENU_PERMISSIONS) {
//     return true;
//   }

//   if (!menuCode) {
//     return false;
//   }

//   if (!Array.isArray(accessPrivileges)) {
//     return false;
//   }

//   return accessPrivileges.some(
//     privilege => String(privilege.AMV_MENU_ID) === String(menuCode)
//   );
// };

// const filterMenusByPermission = (menus, accessPrivileges) => {
//   if (!FEATURE_FLAGS.ENABLE_MENU_PERMISSIONS) {
//     return menus;
//   }

//   if (!Array.isArray(menus)) {
//     return [];
//   }

//   return menus.reduce((result, menu) => {
//     const ownPermission = hasMenuPermission(
//       menu.menuCode,
//       accessPrivileges
//     );

//     const filteredChildren = Array.isArray(menu.children)
//       ? filterMenusByPermission(menu.children, accessPrivileges)
//       : [];

//     if (ownPermission || filteredChildren.length > 0) {
//       result.push({
//         ...menu,
//         children: filteredChildren,
//       });
//     }

//     return result;
//   }, []);
// };

// const filterTopLevelMenusByPermission = (menus, accessPrivileges) => {
//   if (!FEATURE_FLAGS.ENABLE_MENU_PERMISSIONS) {
//     return menus;
//   }

//   return menus.reduce((result, menu) => {
//     const ownPermission = hasMenuPermission(
//       menu.menuCode,
//       accessPrivileges
//     );

//     let childPermission = false;

//     if (menu.menuCode === 'ERP1002') {
//       childPermission = filterMenusByPermission(
//         HR_MODULES,
//         accessPrivileges
//       ).length > 0;
//     }

//     if (menu.menuCode === 'ERP1023') {
//       childPermission = filterMenusByPermission(
//         PAYROLL_MODULES,
//         accessPrivileges
//       ).length > 0;
//     }

//     if (ownPermission || childPermission) {
//       result.push(menu);
//     }

//     return result;
//   }, []);
// };

// export default function Sidebar() {
//   const dispatch = useDispatch();
//   const location = useLocation();
//   const navigate = useNavigate();
//   const { sidebarOpen, activeModule } = useSelector(s => s.ui);
//   const { user } = useSelector(s => s.auth);

//   const {
//     accessPrivileges,
//     accessPrivilegesLoading,
//     accessPrivilegesLoaded
//   } = useSelector(s => s.privilege);

//   const permissionsReady = !FEATURE_FLAGS.ENABLE_MENU_PERMISSIONS || accessPrivilegesLoaded;
//   const [overtimeMenuCollapsed, setOvertimeMenuCollapsed] = useState(true);

//   // Separate enabled and disabled items
//   const enabledNavItems = permissionsReady ? 
//     filterTopLevelMenusByPermission(navItems, accessPrivileges).filter(item => !DISABLED_MENU_CODES.includes(item.menuCode)) : [];

//   const disabledNavItems = permissionsReady ? 
//     navItems.filter(item => DISABLED_MENU_CODES.includes(item.menuCode)) : [];

//   const filteredHRModules = permissionsReady ? filterMenusByPermission(HR_MODULES, accessPrivileges) : [];
//   const filteredPayrollModules = permissionsReady ? filterMenusByPermission(PAYROLL_MODULES, accessPrivileges) : [];

//   const { leaveRequests } = useSelector(s => s.hr);
//   const [hrMenuCollapsed, setHrMenuCollapsed] = useState(false);
//   const [attendanceMenuCollapsed, setAttendanceMenuCollapsed] = useState(true);
//   const [leaveMenuCollapsed, setLeaveMenuCollapsed] = useState(true);

//   useEffect(() => {
//     if (!location.pathname.startsWith('/hrm/')) {
//       setAttendanceMenuCollapsed(true);
//       setLeaveMenuCollapsed(true);
//       setHrMenuCollapsed(false);
//     }
//   }, [location.pathname]);

//   useEffect(() => {
//     if (!location.pathname.startsWith('/hrm/leave')) {
//       setLeaveMenuCollapsed(true);
//     }
//   }, [location.pathname]);

//   useEffect(() => {
//     const userId = getLoggedInUserId();

//     if (userId) {
//       dispatch(fetchAccessPrivilegesByEmployee(userId));
//     }
//   }, [dispatch]);

//   const isHRMActive = location.pathname === '/hrm' || location.pathname.startsWith('/hrm/');
//   const isAttendanceActive = location.pathname.startsWith('/hrm/attendance');
//   const isPayrollActive = location.pathname === '/payroll' || location.pathname.startsWith('/payroll/');
//   const pendingLeave = leaveRequests ? leaveRequests.filter(l => l.status === 'Pending').length : 0;

//   return (
//     <>
//       {sidebarOpen && (
//         <div
//           className="fixed inset-0 bg-black/60 z-20 lg:hidden"
//           onClick={() => dispatch(toggleSidebar())}
//         />
//       )}

//       <aside className={`
//         fixed top-0 left-0 h-full z-30 flex flex-col
//         bg-surface-900 border-r border-surface-700
//         transition-all duration-300 ease-in-out
//         ${sidebarOpen ? 'w-60' : 'w-16'}
//         lg:relative lg:translate-x-0
//         ${!sidebarOpen ? '-translate-x-full lg:translate-x-0' : ''}
//       `}>

//         {/* Logo area */}
//         <div className="flex items-center justify-between px-3 h-16 border-b border-surface-700 shrink-0">
//           {sidebarOpen ? (
//             <div className="flex items-center gap-2 animate-fade-in min-w-0">
//               <img src={tenant.branding.logoUrl} alt="Logo" className="h-8 w-auto object-contain shrink-0" style={{ filter: 'brightness(1)' }} />
//               <div className="min-w-0">
//                 <p className="text-primary-400 text-[10px] font-semibold uppercase tracking-widest truncate">COCO ERP</p>
//               </div>
//             </div>
//           ) : (
//             <div className="w-8 h-8 mx-auto flex items-center justify-center">
//               <img src={tenant.branding.logoUrl} alt="Logo" className="h-7 w-auto object-contain" />
//             </div>
//           )}
//           <button onClick={() => dispatch(toggleSidebar())} className="text-surface-400 hover:text-primary-400 p-1 rounded transition-colors hidden lg:flex shrink-0 ml-1">
//             {sidebarOpen ? <ChevronLeft size={16} /> : <ChevronRight size={16} />}
//           </button>
//           <button onClick={() => dispatch(toggleSidebar())} className="text-surface-300 hover:text-white p-1 rounded transition-colors lg:hidden">
//             <X size={16} />
//           </button>
//         </div>

//         {/* Nav */}
//         <nav className="flex-1 overflow-y-auto py-4 px-2 space-y-0.5">
//           {/* Render enabled items */}
//           {enabledNavItems.map(({ path, label, icon: Icon }) => {
//             const isHRM = path === '/hrm';
//             const isPayroll = path === '/payroll';
//             return (
//               <div key={path}>
//                 <NavLink
//                   to={path}
//                   onClick={() => {
//                     if (isHRM) {
//                       dispatch(setActiveModule('overview'));
//                       setHrMenuCollapsed(false);
//                     }
//                     if (isPayroll) {
//                       dispatch(setActiveModule('p_dashboard'));
//                       setHrMenuCollapsed(false);
//                       setAttendanceMenuCollapsed(true);
//                       setLeaveMenuCollapsed(true);
//                     }
//                     if (!isHRM && !isPayroll) {
//                       setAttendanceMenuCollapsed(true);
//                       setLeaveMenuCollapsed(true);
//                       setHrMenuCollapsed(false);
//                     }
//                   }}
//                   className={({ isActive }) =>
//                     `flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-150 group relative
//                     ${isActive ? 'bg-primary-500 text-surface-900' : 'text-surface-300 hover:bg-surface-700 hover:text-white'}`
//                   }
//                 >
//                   {({ isActive }) => (
//                     <>
//                       <Icon size={18} className={`shrink-0 ${isActive ? 'text-surface-900' : 'text-surface-400 group-hover:text-primary-400'}`} />
//                       {sidebarOpen && <span className="truncate animate-fade-in flex-1">{label}</span>}
//                       {sidebarOpen && ((isHRM && isHRMActive) || (isPayroll && isPayrollActive)) && (
//                         <button
//                           type="button"
//                           onClick={(e) => {
//                             e.preventDefault();
//                             e.stopPropagation();
//                             setHrMenuCollapsed(v => !v);
//                             if (!hrMenuCollapsed) {
//                               setAttendanceMenuCollapsed(true);
//                               setLeaveMenuCollapsed(true);
//                             }
//                           }}
//                           className={`shrink-0 p-0.5 rounded transition-colors ${isActive ? 'text-surface-900 hover:bg-surface-900/10' : 'text-surface-500 hover:bg-surface-600'}`}
//                           title={hrMenuCollapsed ? 'Expand menu' : 'Collapse menu'}
//                         >
//                           <ChevronDown size={14} className={`transition-transform duration-200 ${hrMenuCollapsed ? '' : 'rotate-180'}`} />
//                         </button>
//                       )}
//                       {!sidebarOpen && (
//                         <span className="absolute left-full ml-2 px-2 py-1 bg-surface-700 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-50 shadow-lg">
//                           {label}
//                         </span>
//                       )}
//                     </>
//                   )}
//                 </NavLink>

//                 {/* HR / Payroll Sub-modules */}
//                 {isHRM && isHRMActive && sidebarOpen && !hrMenuCollapsed && (
//                   <div className="mt-1 ml-3 pl-3 border-l-2 border-primary-600/30 space-y-0.5 pb-1">
//                     <p className="text-primary-500/60 text-[9px] font-bold uppercase tracking-widest px-2 pt-1 pb-0.5">HR Management</p>
//                     {filteredHRModules.map(
//                       ({
//                         key,
//                         label: subLabel,
//                         icon: SubIcon,
//                         route,
//                         children
//                       }) => {


//                         if (children && key === 'Overtime') {
//                           const isChildrenActive = children.some(
//                             child => location.pathname === child.route
//                           );

//                           return (
//                             <div key={key}>
//                               <button
//                                 type="button"
//                                 onClick={() => {
//                                   dispatch(setActiveModule(key));
//                                   setOvertimeMenuCollapsed(prev => !prev);
//                                 }}
//                                 className={`w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all text-left
//                                                           ${isChildrenActive || activeModule === key
//                                     ? 'bg-primary-500/20 text-primary-400 border border-primary-500/40'
//                                     : 'text-surface-400 hover:bg-surface-700 hover:text-white'
//                                   }`}
//                               >
//                                 <SubIcon
//                                   size={12}
//                                   className={`shrink-0 ${isChildrenActive || activeModule === key
//                                     ? 'text-primary-400'
//                                     : 'text-surface-500'
//                                     }`}
//                                 />
//                                 <span className="truncate flex-1">
//                                   {subLabel}
//                                 </span>
//                                 <ChevronDown
//                                   size={13}
//                                   className={`shrink-0 transition-transform duration-200 ${overtimeMenuCollapsed ? '' : 'rotate-180'}`}
//                                 />
//                               </button>

//                               {!overtimeMenuCollapsed && (
//                                 <div className="ml-4 pl-3 border-l border-surface-600 mt-0.5 space-y-0.5">
//                                   {children.map(child => (
//                                     <NavLink
//                                       key={child.key}
//                                       to={child.route}
//                                       onClick={() => {
//                                         dispatch(setActiveModule(child.key));
//                                         setOvertimeMenuCollapsed(false);
//                                       }}
//                                       className={({ isActive }) =>
//                                         `w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg
//                                                                 text-[11px] font-medium transition-all text-left
//                                                                 ${isActive || activeModule === child.key
//                                           ? 'bg-primary-500/20 text-primary-400 border border-primary-500/40'
//                                           : 'text-surface-400 hover:bg-surface-700 hover:text-white'
//                                         }`
//                                       }
//                                     >
//                                       <span className="w-1 h-1 rounded-full bg-current shrink-0" />
//                                       <span className="truncate">
//                                         {child.label}
//                                       </span>
//                                     </NavLink>
//                                   ))}
//                                 </div>
//                               )}
//                             </div>
//                           );
//                         }

//                         if (children && key === 'attendance') {
//                           const isChildrenActive = children.some(
//                             child => location.pathname === child.route
//                           );

//                           return (
//                             <div key={key}>
//                               <button
//                                 type="button"
//                                 onClick={() => {
//                                   setAttendanceMenuCollapsed(prev => !prev);
//                                   if (!attendanceMenuCollapsed) {
//                                     setLeaveMenuCollapsed(true);
//                                   }
//                                 }}
//                                 className={`w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all text-left
//                                   ${isChildrenActive || activeModule === key
//                                     ? 'bg-primary-500/20 text-primary-400 border border-primary-500/40'
//                                     : 'text-surface-400 hover:bg-surface-700 hover:text-white'
//                                   }`}
//                               >
//                                 <SubIcon
//                                   size={12}
//                                   className={`shrink-0 ${isChildrenActive || activeModule === key
//                                     ? 'text-primary-400'
//                                     : 'text-surface-500'
//                                     }`}
//                                 />
//                                 <span className="truncate flex-1">
//                                   {subLabel}
//                                 </span>
//                                 <ChevronDown
//                                   size={13}
//                                   className={`shrink-0 transition-transform duration-200 ${attendanceMenuCollapsed ? '' : 'rotate-180'}`}
//                                 />
//                               </button>

//                               {!attendanceMenuCollapsed && (
//                                 <div className="ml-4 pl-3 border-l border-surface-600 mt-0.5 space-y-0.5">
//                                   {children.map(child => (
//                                     <NavLink
//                                       key={child.key}
//                                       to={child.route}
//                                       onClick={() => {
//                                         dispatch(setActiveModule(child.key));
//                                         setAttendanceMenuCollapsed(false);
//                                       }}
//                                       className={({ isActive }) =>
//                                         `w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg
//                                         text-[11px] font-medium transition-all text-left
//                                         ${isActive || activeModule === child.key
//                                           ? 'bg-primary-500/20 text-primary-400 border border-primary-500/40'
//                                           : 'text-surface-400 hover:bg-surface-700 hover:text-white'
//                                         }`
//                                       }
//                                     >
//                                       <span className="w-1 h-1 rounded-full bg-current shrink-0" />
//                                       <span className="truncate">
//                                         {child.label}
//                                       </span>
//                                     </NavLink>
//                                   ))}
//                                 </div>
//                               )}
//                             </div>
//                           );
//                         }

//                         if (children && key === 'leave') {
//                           const isChildrenActive = children.some(
//                             child =>
//                               location.pathname === child.route ||
//                               location.pathname.startsWith('/hrm/leave/')
//                           );

//                           const isMainActive =
//                             location.pathname === '/hrm/leave';

//                           return (
//                             <div key={key}> 
//                               {/* Leave Management Main Menu */}
//                               <div
//                                 className={`w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all
//                                     ${isMainActive ||
//                                     isChildrenActive ||
//                                     activeModule === key
//                                     ? 'bg-primary-500/20 text-primary-400 border border-primary-500/40'
//                                     : 'text-surface-400 hover:bg-surface-700 hover:text-white'
//                                   }`}
//                               >

//                                 <NavLink
//                                   to="/hrm/leave/dashboard"
//                                   onClick={() => {
//                                     dispatch(setActiveModule(key));
//                                   }}
//                                   className="flex items-center gap-2 flex-1 min-w-0"
//                                 >
//                                   <SubIcon
//                                     size={12}
//                                     className={`shrink-0 ${isMainActive ||
//                                       isChildrenActive ||
//                                       activeModule === key
//                                       ? 'text-primary-400'
//                                       : 'text-surface-500'
//                                       }`}
//                                   />

//                                   <span className="truncate">
//                                     {subLabel}
//                                   </span>
//                                 </NavLink>



//                                 <button
//                                   type="button"
//                                   onClick={(e) => {
//                                     e.stopPropagation();

//                                     setLeaveMenuCollapsed(prev => !prev);

//                                     if (leaveMenuCollapsed) {
//                                       setAttendanceMenuCollapsed(true);
//                                     }
//                                   }}
//                                   className="p-1 rounded hover:bg-surface-600 transition-colors"
//                                 >
//                                   <ChevronDown
//                                     size={13}
//                                     className={`shrink-0 transition-transform duration-200 ${leaveMenuCollapsed
//                                       ? ''
//                                       : 'rotate-180'
//                                       }`}
//                                   />
//                                 </button> 
//                               </div> 

//                               {!leaveMenuCollapsed && (
//                                 <div className="ml-4 pl-3 border-l border-surface-600 mt-0.5 space-y-0.5">

//                                   {children.map(child => (
//                                     <NavLink
//                                       key={child.key}
//                                       to={child.route}
//                                       onClick={() => {
//                                         dispatch(setActiveModule(child.key));
//                                         setLeaveMenuCollapsed(false);
//                                       }}
//                                       className={({ isActive }) =>
//                                         `w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-[11px] font-medium transition-all text-left
//                                           ${isActive || activeModule === child.key
//                                           ? 'bg-primary-500/20 text-primary-400 border border-primary-500/40'
//                                           : 'text-surface-400 hover:bg-surface-700 hover:text-white'
//                                         }`
//                                       }
//                                     >
//                                       <span className="w-1 h-1 rounded-full bg-current shrink-0" />

//                                       <span className="truncate">
//                                         {child.label}
//                                       </span>
//                                     </NavLink>
//                                   ))} 
//                                 </div>
//                               )} 
//                             </div>
//                           );
//                         }

//                         if (route) {
//                           return (
//                             <NavLink
//                               key={key}
//                               to={route}
//                               onClick={() => {
//                                 dispatch(setActiveModule(key));
//                                 if (key !== 'attendance' && key !== 'leave') {
//                                   setAttendanceMenuCollapsed(true);
//                                   setLeaveMenuCollapsed(true);
//                                 }
//                               }}
//                               className={({ isActive }) =>
//                                 `w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all text-left
//                                 ${isActive || activeModule === key
//                                   ? 'bg-primary-500/20 text-primary-400 border border-primary-500/40'
//                                   : 'text-surface-400 hover:bg-surface-700 hover:text-white'
//                                 }`
//                               }
//                             >
//                               <SubIcon
//                                 size={12}
//                                 className={`shrink-0 ${activeModule === key
//                                   ? 'text-primary-400'
//                                   : 'text-surface-500'
//                                   }`}
//                               />
//                               <span className="truncate">
//                                 {subLabel}
//                               </span>
//                               {key === 'leave' && pendingLeave > 0 && (
//                                 <span className="ml-auto bg-red-500 text-white text-[9px] rounded-full w-4 h-4 flex items-center justify-center shrink-0">
//                                   {pendingLeave}
//                                 </span>
//                               )}
//                             </NavLink>
//                           );
//                         }

//                         return (
//                           <button
//                             key={key}
//                             onClick={() => {
//                               dispatch(setActiveModule(key));
//                               if (key !== 'attendance' && key !== 'leave') {
//                                 setAttendanceMenuCollapsed(true);
//                                 setLeaveMenuCollapsed(true);
//                               }
//                               if (location.pathname !== '/hrm') {
//                                 navigate('/hrm');
//                               }
//                             }}
//                             className={`w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all text-left
//                               ${activeModule === key
//                                 ? 'bg-primary-500/20 text-primary-400 border border-primary-500/40'
//                                 : 'text-surface-400 hover:bg-surface-700 hover:text-white'
//                               }`}
//                           >
//                             <SubIcon
//                               size={12}
//                               className={`shrink-0 ${activeModule === key
//                                 ? 'text-primary-400'
//                                 : 'text-surface-500'
//                                 }`}
//                             />
//                             <span className="truncate">
//                               {subLabel}
//                             </span>
//                             {key === 'leave' && pendingLeave > 0 && (
//                               <span className="ml-auto bg-red-500 text-white text-[9px] rounded-full w-4 h-4 flex items-center justify-center shrink-0">
//                                 {pendingLeave}
//                               </span>
//                             )}
//                           </button>
//                         );
//                       }
//                     )}
//                   </div>
//                 )}
//                 {isPayroll && isPayrollActive && sidebarOpen && !hrMenuCollapsed && (
//                   <div className="mt-1 ml-3 pl-3 border-l-2 border-primary-600/30 space-y-0.5 pb-1">
//                     <p className="text-primary-500/60 text-[9px] font-bold uppercase tracking-widest px-2 pt-1 pb-0.5">Payroll Process</p>
//                     {filteredPayrollModules.map(({ key, label: subLabel, icon: SubIcon, route }) => (
//                       <NavLink
//                         key={key}
//                         to={route}
//                         end={key === 'p_overtime'}
//                         onClick={() => {
//                           dispatch(setActiveModule(key));
//                           setAttendanceMenuCollapsed(true);
//                           setLeaveMenuCollapsed(true);
//                         }}
//                         className={({ isActive }) =>
//                           `w-full flex items-center gap-2 px-2.5 py-1.5 rounded-lg text-xs font-medium transition-all text-left
//                           ${isActive || activeModule === key
//                             ? 'bg-primary-500/20 text-primary-400 border border-primary-500/40'
//                             : 'text-surface-400 hover:bg-surface-700 hover:text-white'
//                           }`
//                         }
//                       >
//                         <SubIcon size={12} className={`shrink-0 ${activeModule === key ? 'text-primary-400' : 'text-surface-500'}`} />
//                         <span className="truncate">{subLabel}</span>
//                       </NavLink>
//                     ))}
//                   </div>
//                 )}
//               </div>
//             );
//           })}

//           {/* Render disabled items */}
//           {sidebarOpen && disabledNavItems.length > 0 && (
//             <div className="mt-4 pt-2 border-t border-surface-700/50">
//               <p className="text-surface-500 text-[10px] font-medium uppercase tracking-wider px-3 py-1">
//                 Unavailable Modules
//               </p>
//               {disabledNavItems.map(({ menuCode, label, icon: Icon }) => (
//                 <div
//                   key={menuCode}
//                   className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium opacity-40 cursor-not-allowed"
//                 >
//                   <Icon size={18} className="shrink-0 text-surface-500" />
//                   {sidebarOpen && <span className="truncate text-surface-500">{label}</span>}
//                   {!sidebarOpen && (
//                     <span className="absolute left-full ml-2 px-2 py-1 bg-surface-700 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-50 shadow-lg">
//                       {label}
//                     </span>
//                   )}
//                 </div>
//               ))}
//             </div>
//           )}

//           {/* Render disabled items when sidebar is collapsed */}
//           {!sidebarOpen && disabledNavItems.length > 0 && (
//             <>
//               {disabledNavItems.map(({ menuCode, label, icon: Icon }) => (
//                 <div
//                   key={menuCode}
//                   className="relative group opacity-40 cursor-not-allowed"
//                 >
//                   <div className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium">
//                     <Icon size={18} className="shrink-0 text-surface-500" />
//                   </div>
//                   <span className="absolute left-full ml-2 px-2 py-1 bg-surface-700 text-white text-xs rounded whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity z-50 shadow-lg">
//                     {label}
//                   </span>
//                 </div>
//               ))}
//             </>
//           )}
//         </nav>

//         {/* User footer */}
//         {user && (
//           <div className={`border-t border-surface-700 p-3 shrink-0 ${sidebarOpen ? '' : 'flex justify-center'}`}>
//             {sidebarOpen ? (
//               <div className="flex items-center gap-2 animate-fade-in">
//                 <div className="w-8 h-8 primary-gradient rounded-full flex items-center justify-center shrink-0">
//                   <span className="text-surface-900 font-bold text-xs">{user.avatar}</span>
//                 </div>
//                 <div className="min-w-0">
//                   <p className="text-white text-xs font-semibold truncate">{user.name}</p>
//                   <p className="text-surface-400 text-[10px] truncate">{user.role}</p>
//                 </div>
//               </div>
//             ) : (
//               <div className="w-8 h-8 primary-gradient rounded-full flex items-center justify-center">
//                 <span className="text-surface-900 font-bold text-xs">{user.avatar}</span>
//               </div>
//             )}
//           </div>
//         )}
//       </aside>
//     </>
//   );
// }




import React, { useState, useEffect } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { toggleSidebar, setActiveModule } from '../../store/slices/uiSlice';
import tenant from '../../config/tenant';
import {
  LayoutDashboard, Package, Handshake, DollarSign,
  Users, Building2, ShoppingCart, Factory,
  FileSignature, ChevronLeft, ChevronRight, X,
  BarChart2, Briefcase, Clock, Calendar, Award, BookOpen,
  User, ShieldAlert, LogOut, FileText, ChevronDown,
  FolderOpen, Database, Settings, Clock3, Columns, FileSpreadsheet,
  Sparkles, Layers, UserCheck
} from 'lucide-react';
import { getLoggedInUserId } from '../../utils/masterDataUtils';
import { fetchAccessPrivilegesByEmployee } from '../../store/slices/privilegeSlice';

const ENABLE_MENU_PERMISSIONS = tenant.featureFlags?.enableMenuPermissions ?? false;
const DISABLED_MENU_CODES = tenant.featureFlags?.disabledMenuCodes ?? [];

const navItems = [
  { menuCode: 'ERP1001', path: '/dashboard', label: 'Dashboard', icon: LayoutDashboard },
  { menuCode: 'ERP1002', path: '/hrm', label: 'eHRM', icon: Users },
  { menuCode: 'ERP1023', path: '/payroll', label: 'Payroll Process', icon: DollarSign },
  { menuCode: 'ERP1049', path: '/user-management', label: 'User Management', icon: UserCheck },
  { menuCode: 'ERP1038', path: '/asset', label: 'eAsset', icon: Package },
  { menuCode: 'ERP1039', path: '/commercial', label: 'eCommercial', icon: Handshake },
  { menuCode: 'ERP1040', path: '/finance', label: 'eFinancials', icon: DollarSign },
  { menuCode: 'ERP1041', path: '/office', label: 'eOffice', icon: Building2 },
  { menuCode: 'ERP1042', path: '/procurement', label: 'eProcurement', icon: ShoppingCart },
  { menuCode: 'ERP1043', path: '/production', label: 'eProduction', icon: Factory },
  { menuCode: 'ERP1044', path: '/subcontract', label: 'eSubcontract', icon: FileSignature },
];

const HR_MODULES = [
  { menuCode: 'ERP1003', key: 'overview', label: 'Overview', icon: BarChart2, route: '/hrm/dashboard' },
  { menuCode: 'ERP1004', key: 'employees', label: 'Employee Management', icon: Users, route: '/hrm/employees' },
  {
    menuCode: 'ERP1046',
    key: 'Overtime',
    label: 'Overtime Management',
    icon: Clock3,
    route: '/hrm/OtManagement',
    children: [
      {
        menuCode: 'ERP1046_MAIN',
        key: 'ot_dashboard',
        label: 'Overtime Dashboard',
        route: '/hrm/overtime/dashboard'
      },
      {
        menuCode: 'ERP1047',
        key: 'ot_details',
        label: 'Overtime Details',
        route: '/hrm/overtime/details'
      },
    ]
  },
  { menuCode: 'ERP1007', key: 'masterfiles', label: 'Master Files', icon: Database },
  {
    menuCode: 'ERP1008',
    key: 'attendance',
    label: 'Attendance & Shifts',
    icon: Clock,
    children: [
      {
        key: 'attendance-summary',
        label: 'Attendance Dashboard',
        route: '/hrm/attendence-summery'
      },
      {
        menuCode: 'ERP1005',
        key: 'attendance-summary-details',
        label: 'Attendance Summary',
        route: '/hrm/attendance/details'
      },
      {
        menuCode: 'ERP1009',
        key: 'time_adjustments',
        label: 'Time Adjustments',
        route: '/hrm/attendance/adjustments'
      },
      {
        menuCode: 'ERP1010',
        key: 'attendance_approval',
        label: 'Attendance Approval',
        route: '/hrm/attendance/approval'
      },
    ]
  },
  {
    menuCode: 'ERP1011',
    key: 'leave',
    label: 'Leave Management',
    icon: Calendar,
    children: [
      {
        menuCode: 'ERP1012_DASH',
        key: 'leave_dashboard',
        label: 'Leave Dashboard',
        route: '/hrm/leave/dashboard'
      },
      {
        menuCode: 'ERP1015',
        key: 'leave_adjustments',
        label: 'Leave Adjustments',
        route: '/hrm/leave/adjustments'
      },
      {
        menuCode: 'ERP1012',
        key: 'leave_dashboard_reports',
        label: 'Leave History',
        route: '/hrm/leave/more/dashboard-reports'
      },
      {
        menuCode: 'ERP1013',
        key: 'leave_holiday_calendar',
        label: 'Holiday Calendar',
        route: '/hrm/leave/more/holiday-calendar'
      },
      {
        menuCode: 'ERP1014',
        key: 'leave_application_balance',
        label: 'Leave Application',
        route: '/hrm/leave/more/application-balance'
      },
      {
        menuCode: 'ERP1015',
        key: 'leave_configuration',
        label: 'Leave Configuration',
        route: '/hrm/leave/more/configuration'
      },
    ]
  },
];

const PAYROLL_MODULES = [
  { menuCode: 'ERP1024', key: 'p_dashboard', label: 'Dashboard', icon: BarChart2, route: '/payroll/dashboard' },
  { menuCode: 'ERP1025', key: 'p_masterfile', label: 'Master File Maintenance', icon: Database, route: '/payroll/master-file' },
  { menuCode: 'ERP1026', key: 'p_employeesalary', label: 'Employee Salary', icon: Users, route: '/payroll/employee-salary' },
  { menuCode: 'ERP1027', key: 'p_batches', label: 'Payroll Batches', icon: FolderOpen, route: '/payroll/batches' },
  { menuCode: 'ERP1029', key: 'p_loans', label: 'Loans & Advances', icon: DollarSign, route: '/payroll/loans-advances' },
  { menuCode: 'ERP1030', key: 'p_processing', label: 'Payroll Processing', icon: Briefcase, route: '/payroll/processing' },
  { menuCode: 'ERP1038', key: 'p_payrolltext', label: 'Payroll Text File', icon: FileText, route: '/payroll/payroll-text' },
  { menuCode: 'ERP1048', key: 'p_payrolltextcustom', label: 'Custom Text File', icon: Columns, route: '/payroll/payroll-text-custom' },
  { menuCode: 'ERP1033', key: 'p_header', label: 'Payroll Header', icon: FileText, route: '/payroll/header' },
  // { menuCode: 'ERP1028', key: 'p_overtime', label: 'Overtime', icon: Clock, route: '/payroll/overtime' },
  { menuCode: 'ERP1039', key: 'p_salarysummary', label: 'Salary Details Report', icon: FileSpreadsheet, route: '/payroll/salary-summary' },
  { menuCode: 'ERP1036', key: 'p_reports', label: 'Reports', icon: FileText, route: '/payroll/reports' },

  // { menuCode: 'ERP1032', key: 'p_payments', label: 'Payments', icon: DollarSign, route: '/payroll/payments' },

];

const hasMenuPermission = (menuCode, accessPrivileges) => {
  if (!ENABLE_MENU_PERMISSIONS) {
    return true;
  }

  if (!menuCode) {
    return false;
  }

  if (!Array.isArray(accessPrivileges)) {
    return false;
  }

  return accessPrivileges.some(
    privilege => String(privilege.AMV_MENU_ID) === String(menuCode)
  );
};

const filterMenusByPermission = (menus, accessPrivileges) => {
  if (!ENABLE_MENU_PERMISSIONS) {
    return menus;
  }

  if (!Array.isArray(menus)) {
    return [];
  }

  return menus.reduce((result, menu) => {
    const ownPermission = hasMenuPermission(
      menu.menuCode,
      accessPrivileges
    );

    const filteredChildren = Array.isArray(menu.children)
      ? filterMenusByPermission(menu.children, accessPrivileges)
      : [];

    if (ownPermission || filteredChildren.length > 0) {
      result.push({
        ...menu,
        children: filteredChildren,
      });
    }

    return result;
  }, []);
};

const filterTopLevelMenusByPermission = (menus, accessPrivileges) => {
  if (!ENABLE_MENU_PERMISSIONS) {
    return menus;
  }

  return menus.reduce((result, menu) => {
    const ownPermission = hasMenuPermission(
      menu.menuCode,
      accessPrivileges
    );

    let childPermission = false;

    if (menu.menuCode === 'ERP1002') {
      childPermission = filterMenusByPermission(
        HR_MODULES,
        accessPrivileges
      ).length > 0;
    }

    if (menu.menuCode === 'ERP1023') {
      childPermission = filterMenusByPermission(
        PAYROLL_MODULES,
        accessPrivileges
      ).length > 0;
    }

    if (ownPermission || childPermission) {
      result.push(menu);
    }

    return result;
  }, []);
};

export default function Sidebar() {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { sidebarOpen, activeModule } = useSelector(s => s.ui);
  const { user } = useSelector(s => s.auth);

  const {
    accessPrivileges,
    accessPrivilegesLoading,
    accessPrivilegesLoaded
  } = useSelector(s => s.privilege);

  const permissionsReady = !ENABLE_MENU_PERMISSIONS || accessPrivilegesLoaded;
  const [overtimeMenuCollapsed, setOvertimeMenuCollapsed] = useState(true);

  // Separate enabled and disabled items
  const enabledNavItems = permissionsReady ?
    filterTopLevelMenusByPermission(navItems, accessPrivileges).filter(item => !DISABLED_MENU_CODES.includes(item.menuCode)) : [];

  const disabledNavItems = permissionsReady ?
    navItems.filter(item => DISABLED_MENU_CODES.includes(item.menuCode)) : [];

  const filteredHRModules = permissionsReady ? filterMenusByPermission(HR_MODULES, accessPrivileges) : [];
  const filteredPayrollModules = permissionsReady ? filterMenusByPermission(PAYROLL_MODULES, accessPrivileges) : [];

  const { leaveRequests } = useSelector(s => s.hr);
  const [hrMenuCollapsed, setHrMenuCollapsed] = useState(false);
  const [attendanceMenuCollapsed, setAttendanceMenuCollapsed] = useState(true);
  const [leaveMenuCollapsed, setLeaveMenuCollapsed] = useState(true);

  useEffect(() => {
    if (!location.pathname.startsWith('/hrm/')) {
      setAttendanceMenuCollapsed(true);
      setLeaveMenuCollapsed(true);
      setHrMenuCollapsed(false);
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!location.pathname.startsWith('/hrm/leave')) {
      setLeaveMenuCollapsed(true);
    }
  }, [location.pathname]);

  useEffect(() => {
    const userId = getLoggedInUserId();

    if (userId) {
      dispatch(fetchAccessPrivilegesByEmployee(userId));
    }
  }, [dispatch]);

  const isHRMActive = location.pathname === '/hrm' || location.pathname.startsWith('/hrm/');
  const isAttendanceActive = location.pathname.startsWith('/hrm/attendance');
  const isPayrollActive = location.pathname === '/payroll' || location.pathname.startsWith('/payroll/');
  const pendingLeave = leaveRequests ? leaveRequests.filter(l => l.status === 'Pending').length : 0;

  return (
    <>
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/60 z-20 lg:hidden"
          onClick={() => dispatch(toggleSidebar())}
        />
      )}

      <aside className={`
        fixed top-0 left-0 h-full z-30 flex flex-col
        bg-gradient-to-b from-surface-900 via-surface-800 to-surface-700
        border-r border-primary-800/30
        transition-all duration-300 ease-in-out
        ${sidebarOpen ? 'w-64' : 'w-16'}
        lg:relative lg:translate-x-0
        ${!sidebarOpen ? '-translate-x-full lg:translate-x-0' : ''}
        shadow-2xl shadow-black/40
      `}>

        {/* Decorative gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-br from-primary-500/5 via-transparent to-primary-500/10 pointer-events-none" />

        {/* Glow effect at top */}
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-48 h-32 bg-primary-500/10 rounded-full blur-3xl pointer-events-none" />

        {/* Logo area */}
        <div className="relative flex items-center justify-between px-4 h-16 border-b border-primary-800/30 shrink-0 bg-black/30 backdrop-blur-sm">
          {sidebarOpen ? (
            <div className="flex items-center gap-3 animate-fade-in min-w-0">
              <div className="relative">
                <div className="absolute -inset-1 bg-primary-400/10 rounded-full blur-md" />
                <img src={tenant.branding.logoUrl} alt="Logo" className="relative h-10 w-auto object-contain shrink-0" />
              </div>
              <div className="min-w-0">
                <p className="text-sm font-bold uppercase tracking-[0.2em] truncate">
                  {(tenant.branding.appName || 'ERP System')
                    .trim()
                    .split(/\s+/)
                    .map((word, index) => (
                      <React.Fragment key={`${word}-${index}`}>
                        {index > 0 && ' '}
                        <span className="text-white">{word.charAt(0)}</span>
                        <span className="text-primary-300">{word.slice(1)}</span>
                      </React.Fragment>
                    ))}
                </p>
              </div>
            </div>
          ) : (
            <div className="relative w-9 h-9 mx-auto flex items-center justify-center">
              <div className="absolute -inset-1 bg-primary-400/10 rounded-full blur-md" />
              <img src={tenant.branding.logoUrl} alt="Logo" className="relative h-8 w-auto object-contain" />
            </div>
          )}
          <button
            onClick={() => dispatch(toggleSidebar())}
            className="relative text-primary-300 hover:text-primary-100 p-1.5 rounded-lg transition-all duration-200 hover:bg-primary-500/20 hover:scale-105 hidden lg:flex shrink-0 ml-1"
          >
            {sidebarOpen ? <ChevronLeft size={18} /> : <ChevronRight size={18} />}
          </button>
          <button
            onClick={() => dispatch(toggleSidebar())}
            className="relative text-primary-300 hover:text-white p-1.5 rounded-lg transition-all duration-200 hover:bg-primary-500/20 lg:hidden"
          >
            <X size={18} />
          </button>
        </div>

        {/* Nav */}
        <nav className="relative flex-1 overflow-y-auto py-4 px-2 space-y-0.5 custom-scrollbar">
          <style>{`
            .custom-scrollbar::-webkit-scrollbar {
              width: 4px;
            }
            .custom-scrollbar::-webkit-scrollbar-track {
              background: transparent;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb {
              background: ${tenant.theme.primary[500]}66;
              border-radius: 10px;
            }
            .custom-scrollbar::-webkit-scrollbar-thumb:hover {
              background: ${tenant.theme.primary[500]}99;
            }
          `}</style>

          {/* Render enabled items */}
          {enabledNavItems.map(({ path, label, icon: Icon }) => {
            const isHRM = path === '/hrm';
            const isPayroll = path === '/payroll';

            return (
              <div key={path}>
                <NavLink
                  to={path}
                  onClick={() => {
                    if (isHRM) {
                      dispatch(setActiveModule('overview'));
                      setHrMenuCollapsed(false);
                    }
                    if (isPayroll) {
                      dispatch(setActiveModule('p_dashboard'));
                      setHrMenuCollapsed(false);
                      setAttendanceMenuCollapsed(true);
                      setLeaveMenuCollapsed(true);
                    }
                    if (!isHRM && !isPayroll) {
                      setAttendanceMenuCollapsed(true);
                      setLeaveMenuCollapsed(true);
                      setHrMenuCollapsed(false);
                    }
                  }}
                  className={({ isActive: navActive }) =>
                    `relative flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-200 group
                    ${navActive
                      ? 'bg-gradient-to-r from-primary-500/30 to-primary-400/10 text-white shadow-lg shadow-primary-500/20 border border-primary-500/40'
                      : 'text-primary-100/70 hover:text-white hover:bg-primary-500/20 hover:shadow-md hover:shadow-primary-500/10'
                    }`
                  }
                >
                  {({ isActive: navActive }) => (
                    <>
                      {/* Active indicator */}
                      {navActive && (
                        <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1 h-8 bg-gradient-to-b from-primary-400 to-primary-300 rounded-r-full shadow-lg shadow-primary-400/50" />
                      )}

                      <Icon
                        size={20}
                        className={`shrink-0 transition-all duration-200 ${navActive
                            ? 'text-primary-300 drop-shadow-md'
                            : 'text-surface-400 group-hover:text-primary-300'
                          }`}
                      />

                      {sidebarOpen && (
                        <span className={`truncate animate-fade-in flex-1 text-base font-medium ${navActive ? 'text-white' : 'text-surface-200'
                          }`}>
                          {label}
                        </span>
                      )}

                      {sidebarOpen && ((isHRM && isHRMActive) || (isPayroll && isPayrollActive)) && (
                        <button
                          type="button"
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setHrMenuCollapsed(v => !v);
                            if (!hrMenuCollapsed) {
                              setAttendanceMenuCollapsed(true);
                              setLeaveMenuCollapsed(true);
                            }
                          }}
                          className={`shrink-0 p-0.5 rounded transition-all duration-200 hover:bg-primary-500/20 ${navActive
                              ? 'text-primary-300 hover:text-primary-100'
                              : 'text-primary-400 hover:text-primary-300'
                            }`}
                          title={hrMenuCollapsed ? 'Expand menu' : 'Collapse menu'}
                        >
                          <ChevronDown size={16} className={`transition-transform duration-200 ${hrMenuCollapsed ? '' : 'rotate-180'}`} />
                        </button>
                      )}

                      {!sidebarOpen && (
                        <span className="absolute left-full ml-2 px-3 py-1.5 bg-surface-900 text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 z-50 shadow-xl shadow-black/50 border border-surface-700 backdrop-blur-sm font-medium">
                          {label}
                        </span>
                      )}
                    </>
                  )}
                </NavLink>

                {/* HR / Payroll Sub-modules */}
                {isHRM && isHRMActive && sidebarOpen && !hrMenuCollapsed && (
                  <div className="mt-1 ml-3 pl-3 border-l-2 border-primary-500/30 space-y-0.5 pb-1">
                    <p className="text-primary-400/70 text-[10px] font-bold uppercase tracking-[0.2em] px-2 pt-1 pb-0.5 flex items-center gap-1.5">
                      <Sparkles size={12} className="text-primary-400" />
                      HR Management
                    </p>
                    {filteredHRModules.map(
                      ({
                        key,
                        label: subLabel,
                        icon: SubIcon,
                        route,
                        children
                      }) => {
                        if (children && key === 'Overtime') {
                          const isChildrenActive = children.some(
                            child => location.pathname === child.route
                          );

                          return (
                            <div key={key}>
                              <button
                                type="button"
                                onClick={() => {
                                  dispatch(setActiveModule(key));
                                  setOvertimeMenuCollapsed(prev => !prev);
                                }}
                                className={`w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm font-medium transition-all duration-200 text-left
                                  ${isChildrenActive || activeModule === key
                                    ? 'bg-primary-500/25 text-white border border-primary-500/40 shadow-sm shadow-primary-500/15'
                                    : 'text-primary-100/70 hover:text-white hover:bg-primary-500/15'
                                  }`}
                              >
                                <SubIcon
                                  size={14}
                                  className={`shrink-0 transition-colors duration-200 ${isChildrenActive || activeModule === key
                                      ? 'text-primary-300'
                                      : 'text-primary-400/60'
                                    }`}
                                />
                                <span className="truncate flex-1">
                                  {subLabel}
                                </span>
                                <ChevronDown
                                  size={14}
                                  className={`shrink-0 transition-transform duration-200 ${overtimeMenuCollapsed ? '' : 'rotate-180'
                                    } text-primary-400/60`}
                                />
                              </button>

                              {!overtimeMenuCollapsed && (
                                <div className="ml-4 pl-3 border-l border-primary-700/30 mt-0.5 space-y-0.5">
                                  {children.map(child => {
                                    const isChildActive = location.pathname === child.route;
                                    return (
                                      <NavLink
                                        key={child.key}
                                        to={child.route}
                                        onClick={() => {
                                          dispatch(setActiveModule(child.key));
                                          setOvertimeMenuCollapsed(false);
                                        }}
                                        className={`w-full flex items-center gap-2.5 px-2.5 py-1.5 rounded-lg text-sm font-medium transition-all duration-200 text-left
                                          ${isChildActive || activeModule === child.key
                                            ? 'bg-primary-500/25 text-white border border-primary-500/40'
                                            : 'text-primary-100/60 hover:text-white hover:bg-primary-500/10'
                                          }`}
                                      >
                                        <span className="w-1.5 h-1.5 rounded-full bg-primary-400/60 shrink-0" />
                                        <span className="truncate">
                                          {child.label}
                                        </span>
                                      </NavLink>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          );
                        }

                        if (children && key === 'attendance') {
                          const isChildrenActive = children.some(
                            child => location.pathname === child.route
                          );

                          return (
                            <div key={key}>
                              <button
                                type="button"
                                onClick={() => {
                                  setAttendanceMenuCollapsed(prev => !prev);
                                  if (!attendanceMenuCollapsed) {
                                    setLeaveMenuCollapsed(true);
                                  }
                                }}
                                className={`w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm font-medium transition-all duration-200 text-left
                                  ${isChildrenActive || activeModule === key
                                    ? 'bg-primary-500/25 text-white border border-primary-500/40 shadow-sm shadow-primary-500/15'
                                    : 'text-primary-100/70 hover:text-white hover:bg-primary-500/15'
                                  }`}
                              >
                                <SubIcon
                                  size={14}
                                  className={`shrink-0 transition-colors duration-200 ${isChildrenActive || activeModule === key
                                      ? 'text-primary-300'
                                      : 'text-primary-400/60'
                                    }`}
                                />
                                <span className="truncate flex-1">
                                  {subLabel}
                                </span>
                                <ChevronDown
                                  size={14}
                                  className={`shrink-0 transition-transform duration-200 ${attendanceMenuCollapsed ? '' : 'rotate-180'
                                    } text-primary-400/60`}
                                />
                              </button>

                              {!attendanceMenuCollapsed && (
                                <div className="ml-4 pl-3 border-l border-primary-700/30 mt-0.5 space-y-0.5">
                                  {children.map(child => {
                                    const isChildActive = location.pathname === child.route;
                                    return (
                                      <NavLink
                                        key={child.key}
                                        to={child.route}
                                        onClick={() => {
                                          dispatch(setActiveModule(child.key));
                                          setAttendanceMenuCollapsed(false);
                                        }}
                                        className={`w-full flex items-center gap-2.5 px-2.5 py-1.5 rounded-lg text-sm font-medium transition-all duration-200 text-left
                                          ${isChildActive || activeModule === child.key
                                            ? 'bg-primary-500/25 text-white border border-primary-500/40'
                                            : 'text-primary-100/60 hover:text-white hover:bg-primary-500/10'
                                          }`}
                                      >
                                        <span className="w-1.5 h-1.5 rounded-full bg-primary-400/60 shrink-0" />
                                        <span className="truncate">
                                          {child.label}
                                        </span>
                                      </NavLink>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          );
                        }

                        if (children && key === 'leave') {
                          const isChildrenActive = children.some(
                            child =>
                              location.pathname === child.route ||
                              location.pathname.startsWith('/hrm/leave/')
                          );

                          const isMainActive =
                            location.pathname === '/hrm/leave';

                          return (
                            <div key={key}>
                              <div
                                className={`w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm font-medium transition-all duration-200
                                    ${isMainActive ||
                                    isChildrenActive ||
                                    activeModule === key
                                    ? 'bg-primary-500/25 text-white border border-primary-500/40 shadow-sm shadow-primary-500/15'
                                    : 'text-primary-100/70 hover:text-white hover:bg-primary-500/15'
                                  }`}
                              >
                                <NavLink
                                  to="/hrm/leave/dashboard"
                                  onClick={() => {
                                    dispatch(setActiveModule(key));
                                  }}
                                  className="flex items-center gap-2.5 flex-1 min-w-0"
                                >
                                  <SubIcon
                                    size={14}
                                    className={`shrink-0 transition-colors duration-200 ${isMainActive ||
                                        isChildrenActive ||
                                        activeModule === key
                                        ? 'text-primary-300'
                                        : 'text-primary-400/60'
                                      }`}
                                  />
                                  <span className="truncate">
                                    {subLabel}
                                  </span>
                                </NavLink>

                                <button
                                  type="button"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setLeaveMenuCollapsed(prev => !prev);
                                    if (leaveMenuCollapsed) {
                                      setAttendanceMenuCollapsed(true);
                                    }
                                  }}
                                  className="p-1 rounded hover:bg-primary-500/20 transition-colors duration-200"
                                >
                                  <ChevronDown
                                    size={14}
                                    className={`shrink-0 transition-transform duration-200 ${leaveMenuCollapsed ? '' : 'rotate-180'
                                      } text-primary-400/60`}
                                  />
                                </button>
                              </div>

                              {!leaveMenuCollapsed && (
                                <div className="ml-4 pl-3 border-l border-primary-700/30 mt-0.5 space-y-0.5">
                                  {children.map(child => {
                                    const isChildActive = location.pathname === child.route;
                                    return (
                                      <NavLink
                                        key={child.key}
                                        to={child.route}
                                        onClick={() => {
                                          dispatch(setActiveModule(child.key));
                                          setLeaveMenuCollapsed(false);
                                        }}
                                        className={`w-full flex items-center gap-2.5 px-2.5 py-1.5 rounded-lg text-sm font-medium transition-all duration-200 text-left
                                          ${isChildActive || activeModule === child.key
                                            ? 'bg-primary-500/25 text-white border border-primary-500/40'
                                            : 'text-primary-100/60 hover:text-white hover:bg-primary-500/10'
                                          }`}
                                      >
                                        <span className="w-1.5 h-1.5 rounded-full bg-primary-400/60 shrink-0" />
                                        <span className="truncate">
                                          {child.label}
                                        </span>
                                      </NavLink>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          );
                        }

                        if (route) {
                          const isRouteActive = location.pathname === route;
                          return (
                            <NavLink
                              key={key}
                              to={route}
                              onClick={() => {
                                dispatch(setActiveModule(key));
                                if (key !== 'attendance' && key !== 'leave') {
                                  setAttendanceMenuCollapsed(true);
                                  setLeaveMenuCollapsed(true);
                                }
                              }}
                              className={`w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm font-medium transition-all duration-200 text-left
                                ${isRouteActive || activeModule === key
                                  ? 'bg-primary-500/25 text-white border border-primary-500/40 shadow-sm shadow-primary-500/15'
                                  : 'text-primary-100/70 hover:text-white hover:bg-primary-500/15'
                                }`}
                            >
                              <SubIcon
                                size={14}
                                className={`shrink-0 transition-colors duration-200 ${isRouteActive || activeModule === key
                                    ? 'text-primary-300'
                                    : 'text-primary-400/60'
                                  }`}
                              />
                              <span className="truncate">
                                {subLabel}
                              </span>
                              {key === 'leave' && pendingLeave > 0 && (
                                <span className="ml-auto bg-gradient-to-r from-primary-500 to-primary-400 text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center shrink-0 shadow-lg shadow-primary-500/30">
                                  {pendingLeave}
                                </span>
                              )}
                            </NavLink>
                          );
                        }

                        return (
                          <button
                            key={key}
                            onClick={() => {
                              dispatch(setActiveModule(key));
                              if (key !== 'attendance' && key !== 'leave') {
                                setAttendanceMenuCollapsed(true);
                                setLeaveMenuCollapsed(true);
                              }
                              if (location.pathname !== '/hrm') {
                                navigate('/hrm');
                              }
                            }}
                            className={`w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm font-medium transition-all duration-200 text-left
                              ${activeModule === key
                                ? 'bg-primary-500/25 text-white border border-primary-500/40 shadow-sm shadow-primary-500/15'
                                : 'text-primary-100/70 hover:text-white hover:bg-primary-500/15'
                              }`}
                          >
                            <SubIcon
                              size={14}
                              className={`shrink-0 transition-colors duration-200 ${activeModule === key
                                  ? 'text-primary-300'
                                  : 'text-primary-400/60'
                                }`}
                            />
                            <span className="truncate">
                              {subLabel}
                            </span>
                            {key === 'leave' && pendingLeave > 0 && (
                              <span className="ml-auto bg-gradient-to-r from-primary-500 to-primary-400 text-white text-[10px] font-bold rounded-full w-5 h-5 flex items-center justify-center shrink-0 shadow-lg shadow-primary-500/30">
                                {pendingLeave}
                              </span>
                            )}
                          </button>
                        );
                      }
                    )}
                  </div>
                )}
                {isPayroll && isPayrollActive && sidebarOpen && !hrMenuCollapsed && (
                  <div className="mt-1 ml-3 pl-3 border-l-2 border-primary-500/30 space-y-0.5 pb-1">
                    <p className="text-primary-400/70 text-[10px] font-bold uppercase tracking-[0.2em] px-2 pt-1 pb-0.5 flex items-center gap-1.5">
                      <Layers size={12} className="text-primary-400" />
                      Payroll Process
                    </p>
                    {filteredPayrollModules.map(({ key, label: subLabel, icon: SubIcon, route }) => {
                      const isRouteActive = location.pathname === route;
                      return (
                        <NavLink
                          key={key}
                          to={route}
                          end={key === 'p_overtime'}
                          onClick={() => {
                            dispatch(setActiveModule(key));
                            setAttendanceMenuCollapsed(true);
                            setLeaveMenuCollapsed(true);
                          }}
                          className={`w-full flex items-center gap-2.5 px-2.5 py-2 rounded-lg text-sm font-medium transition-all duration-200 text-left
                            ${isRouteActive || activeModule === key
                              ? 'bg-primary-500/25 text-white border border-primary-500/40 shadow-sm shadow-primary-500/15'
                              : 'text-primary-100/70 hover:text-white hover:bg-primary-500/15'
                            }`}
                        >
                          <SubIcon
                            size={14}
                            className={`shrink-0 transition-colors duration-200 ${isRouteActive || activeModule === key
                                ? 'text-primary-300'
                                : 'text-primary-400/60'
                              }`}
                          />
                          <span className="truncate">{subLabel}</span>
                        </NavLink>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}

          {/* Render disabled items */}
          {sidebarOpen && disabledNavItems.length > 0 && (
            <div className="mt-4 pt-3 border-t border-primary-800/20">
              <p className="text-primary-400/40 text-[10px] font-medium uppercase tracking-wider px-3 py-1 flex items-center gap-1.5">
                <span className="w-1 h-1 rounded-full bg-primary-400/40" />
                Unavailable Modules
              </p>
              {disabledNavItems.map(({ menuCode, label, icon: Icon }) => (
                <div
                  key={menuCode}
                  className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium opacity-40 cursor-not-allowed"
                >
                  <Icon size={20} className="shrink-0 text-primary-400/40" />
                  {sidebarOpen && <span className="truncate text-primary-400/40 text-base">{label}</span>}
                </div>
              ))}
            </div>
          )}

          {/* Render disabled items when sidebar is collapsed */}
          {!sidebarOpen && disabledNavItems.length > 0 && (
            <>
              {disabledNavItems.map(({ menuCode, label, icon: Icon }) => (
                <div
                  key={menuCode}
                  className="relative group opacity-40 cursor-not-allowed"
                >
                  <div className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium">
                    <Icon size={20} className="shrink-0 text-primary-400/40" />
                  </div>
                  <span className="absolute left-full ml-2 px-3 py-1.5 bg-[#0a0a0a] text-white text-sm rounded-lg whitespace-nowrap opacity-0 group-hover:opacity-100 pointer-events-none transition-opacity duration-200 z-50 shadow-xl shadow-black/50 border border-primary-700/30 font-medium">
                    {label}
                  </span>
                </div>
              ))}
            </>
          )}
        </nav>

        {/* User footer */}
        {user && (
          <div className={`relative border-t border-primary-800/30 p-3 shrink-0 bg-black/30 backdrop-blur-sm ${sidebarOpen ? '' : 'flex justify-center'
            }`}>
            {sidebarOpen ? (
              <div className="flex items-center gap-3 animate-fade-in">
                <div className="relative">
                  <div className="absolute -inset-0.5 bg-gradient-to-r from-primary-400 to-primary-500 rounded-full blur-sm opacity-40" />
                  <div className="relative w-10 h-10 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full flex items-center justify-center shrink-0 shadow-lg shadow-primary-500/30">
                    <span className="text-white font-bold text-sm">{user.avatar}</span>
                  </div>
                </div>
                <div className="min-w-0">
                  <p className="text-white text-sm font-semibold truncate">{user.name}</p>
                  <p className="text-primary-300/70 text-xs truncate flex items-center gap-1">
                    <span className="w-1 h-1 rounded-full bg-primary-400/60" />
                    {user.role}
                  </p>
                </div>
              </div>
            ) : (
              <div className="relative">
                <div className="absolute -inset-0.5 bg-gradient-to-r from-primary-400 to-primary-500 rounded-full blur-sm opacity-40" />
                <div className="relative w-10 h-10 bg-gradient-to-br from-primary-400 to-primary-600 rounded-full flex items-center justify-center shadow-lg shadow-primary-500/30">
                  <span className="text-white font-bold text-sm">{user.avatar}</span>
                </div>
              </div>
            )}
          </div>
        )}
      </aside>
    </>
  );
}